import React from 'react'
import MessageUI from '../output/MessageUI'
import LRTableRowUI from './LRTableRowUI'
import './ViewOrUpdate.css'

/* {context, messageList, viewState, labelMessageKey, rightViewUI, updateUI, setViewState, setUpdateState} */
/* https://stackoverflow.com/questions/36750387/react-adding-props-to-an-existing-component */

class ViewOrUpdateUI extends React.Component {
  render() {
    let cloned = React.cloneElement(
      this.props.updateUI, { onCancel: this.props.setViewState }
    );

    return (
      <React.Fragment>
        {
          this.props.viewState &&
          <LRTableRowUI
            context={this.props.context}
            left={<label><MessageUI messageList={this.props.messageList} messageKey={this.props.labelMessageKey} /></label>}
            right={this.props.rightViewUI}
            onClick={this.props.setUpdateState}
          />
        }
        {
          !this.props.viewState &&
          <React.Fragment>
            {cloned}
          </React.Fragment>
        }
      </React.Fragment>
    )
  }
}

export default ViewOrUpdateUI
